import config from 'config';
import { useCallback } from 'react';
import ScheduleConsultation from 'domains/consultations/Components/ScheduleConsultation';
import { TimeZone } from 'domains/timezone';
import { ScheduleContext, withScheduleMachineState } from 'domains/signup/consultationSchedule/data/ScheduleContext';
import { AvailableTimes } from 'domains/calendars/types';

const ScheduleWrapper = () => {
  const availableConsultDates = ScheduleContext.useSelector(({ context }) => context.availableConsultDates);
  const { send } = ScheduleContext.useActorRef();

  const onSubmit = useCallback(
    (value: Date, displayTimezone: TimeZone) => {
      send({
        type: 'submitConsultationDate',
        consultationDate: value,
        consultationTimezone: displayTimezone,
      });
    },
    [send],
  );

  return (
    <ScheduleConsultation
      onSubmit={onSubmit}
      availableTimes={availableConsultDates as AvailableTimes}
      supportEmail={config.get('supportEmail')}
    />
  );
};

export const ScheduleEnterConsultationDate = withScheduleMachineState(ScheduleWrapper, 'enterConsultationDate');
